import { createFileRoute } from '@tanstack/react-router';
import { TimesheetPage } from '@/features/time/timesheet-page';

export const Route = createFileRoute('/w/$workspaceId/timesheet')({ component: TimesheetPage });
